// Meta_Digital is the IVR's label for every inbound call, not a Meta campaign; older snapshots stored it as a source.
export function sourceLabel(value: unknown): string {
  const label = String(value ?? '').trim();
  return label === 'Direct Calls' || label === 'Meta Digital' ? 'Inbound Calls (IVR)' : label;
}
